/**
 * Keeps PDP wishlist placeholder in sync with selected variant,
 * and aria-label with selected / idle label copy.
 */
const PDP_WISHLIST_BUTTON_SELECTOR = '.wishlist-pdp-button .wkh-button[data-variant-id]';

function isWishlistSelected(button) {
  return button.classList.contains('wk-selected') || button.classList.contains('wkh-selected');
}

function syncWishlistAriaLabel(button) {
  const addLabel = button.dataset.labelAdd;
  const savedLabel = button.dataset.labelSaved;
  if (!addLabel || !savedLabel) {
    return;
  }

  const selected = isWishlistSelected(button);
  button.setAttribute('aria-pressed', selected ? 'true' : 'false');
  button.setAttribute('aria-label', selected ? savedLabel : addLabel);
}

function observeWishlistSelection(button) {
  if (button.dataset.wishlistLabelObserver === '1') {
    return;
  }
  button.dataset.wishlistLabelObserver = '1';
  syncWishlistAriaLabel(button);

  const observer = new MutationObserver(() => {
    syncWishlistAriaLabel(button);
  });
  observer.observe(button, { attributes: true, attributeFilter: ['class'] });
}

document.addEventListener('variant:change', (event) => {
  const variant = event.detail?.variant;
  if (!variant?.id) {
    return;
  }

  const variantId = String(variant.id);

  const productForm = document.querySelector('product-form[data-swish-product-handle]');
  if (productForm) {
    productForm.setAttribute('data-swish-variant-id', variantId);
  }

  document.querySelectorAll(PDP_WISHLIST_BUTTON_SELECTOR).forEach((button) => {
    if (button.dataset.variantId === variantId) {
      return;
    }

    button.dataset.variantId = variantId;
  });

  document.querySelectorAll('wishlist-button-block').forEach((wishlistButton) => {
    wishlistButton.setAttribute('data-variant-id', variantId);
    wishlistButton.dispatchEvent(
      new CustomEvent('wk:variant:change', {
        detail: { variantId: variant.id },
        bubbles: true,
      })
    );
  });
});

document.querySelectorAll(PDP_WISHLIST_BUTTON_SELECTOR).forEach(observeWishlistSelection);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(PDP_WISHLIST_BUTTON_SELECTOR).forEach(observeWishlistSelection);
});
